import script from "./Notes.vue?vue&type=script&setup=true&lang=js"
export * from "./Notes.vue?vue&type=script&setup=true&lang=js"

import "./Notes.vue?vue&type=style&index=0&id=1772e74e&lang=css"

const __exports__ = script;

export default __exports__